import classNames from "classnames"
import React from "react"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  id: string
  text: string
  tooltipText: string
}

// Note: this is meant to work as pure html and css using react-dom renderToString.
// On the smallest screens (< sm) the tooltip is a fixed, screen-centered overlay;
// its vertical position is nudged to sit just above the label via JS in PlanFeature
// (a fixed element can't track the label with CSS alone).
const PlanFeatureTooltip = ({ id, text, tooltipText }: Props) => {
  const checkboxId = `plan-feature-tooltip-${id}`

  return (
    <span className="group/plan-feature-tooltip relative z-30 inline-block">
      {/* Hidden checkbox to control toggle state of the tooltip on mobile */}
      <input type="checkbox" className="absolute hidden" id={checkboxId} />

      <label htmlFor={checkboxId} className="cursor-pointer md:cursor-default">
        <Typography
          element="span"
          text={text}
          font="grotesk"
          weight="medium"
          size="body-sm"
          color={Color.Blue}
          className="underline decoration-dotted underline-offset-4"
        />
      </label>

      <span
        data-plan-feature-tooltip-bubble
        className={classNames(
          "pointer-events-none fixed left-1/2 top-1/2 z-30 w-max max-w-[240px] -translate-x-1/2 -translate-y-1/2 justify-center rounded-[10px] px-12 py-8 text-center opacity-0 shadow-lg transition-opacity duration-200 ease-in-out max-md:group-has-[:checked]/plan-feature-tooltip:pointer-events-auto max-md:group-has-[:checked]/plan-feature-tooltip:opacity-100 sm:absolute sm:bottom-full sm:top-auto sm:mb-10 sm:translate-y-0 md:mb-8 md:group-hover/plan-feature-tooltip:pointer-events-auto md:group-hover/plan-feature-tooltip:opacity-100",
          getBackgroundColorClass(Color.Charcoal)
        )}
      >
        <Typography
          element="span"
          text={tooltipText}
          font="grotesk"
          weight="book"
          size="body-sm"
          color={Color.White}
        />
      </span>
    </span>
  )
}

export default PlanFeatureTooltip
